import {
  Button,
  Checkbox,
  Col,
  Form,
  notification,
  Radio,
  Row,
  Select,
  Divider,
  Spin,
} from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { Label } from '../../../compnents/widgets/Label'
import styles from './personalSetting.module.css'
import {
  Checks,
  Settinglable,
} from '../../../models/personalSetting'
import { useQuery } from '../../../utils/HttpUtils'
import {
  getAllPersonalPreferences,
  getUserProfileList,
  saveSetting,
} from '../personalDetail/personalDetailSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import _ from 'lodash'
import {
  selectUserId,
} from '../../../app/applicationSlice'
import { getPrintTemplateSettingList } from '../../print/printSlice'

export const OtherSettings = (props: {
  selectedTab: any
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const query = useQuery()

  const userId = useSelector(selectUserId)

  const id = query.get('id') as string

  const { Option } = Select

  const [form] = Form.useForm()

  const [checkData, setCheckData] = useState<any>([])

  const [submitLoading, setSubmitLoading] = useState(false)

  const [loading, setLoading] = useState(false)

  const [printFlag, setPrintFlag] = useState<any>(false)

  const [templateList, setTemplateList] = useState<any>()

  const getShowData = () => {
    setLoading(true)
    dispatch(getUserProfileList({ userId: id }))
      .then(unwrapResult)
      .then((c: any) => {
        setCheckData(c)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    if (props?.selectedTab == '4') {
      getShowData()
    }
  }, [dispatch, props?.selectedTab])

  useEffect(() => {
    const SRFSZValue = checkData?.filter((v: any) => v?.code == '5')?.[0]
      ?.codeName  //输入法设置

    const XCXQXValue = checkData?.filter((v: any) => v?.code == '7')?.[0]
      ?.codeName  //小程序权限


    const FPXZValue = checkData?.filter((v: any) => v?.code == '12')?.[0]
      ?.codeName  //发票选择

    const TLXCFHBBHBValue = checkData?.filter((v: any) => v?.code == '13')?.[0]
      ?.codeName  //同类型处方合并不合并

    const JSHZDTDYYLValue = checkData?.filter((v: any) => v?.code == '14')?.[0]
      ?.codeName  //结算后自动跳打印预览

    const templateListIds = templateList?.map((v: any) => v?.templateId)

    const FPXZValueId = FPXZValue ? FPXZValue?.split(',') : []

    const existingNumbers = FPXZValueId?.length
      ? FPXZValueId?.filter((num: any) =>
        templateListIds?.includes(num)
      )?.join(',')
      : FPXZValue

    form.setFieldsValue({
      [Checks.SRFSZ]: SRFSZValue ? SRFSZValue : '0', //输入法设置

      [Checks.XCXQX]: XCXQXValue == 'true' ? true : false, //小程序权限

      [Checks.FPXZ]: existingNumbers ? existingNumbers?.split(',').map(String) : [], //自动打印发票选择

      [Checks.TLXCFHBBHB]: TLXCFHBBHBValue == 'true' ? true : TLXCFHBBHBValue == 'false' ? false : true, //同类型处方合并不合并

      [Checks.JSHZDTDYYL]: JSHZDTDYYLValue == 'true' ? true : (JSHZDTDYYLValue ? false : true), //结算后自动跳打印预览
    })

    setPrintFlag(FPXZValue ? true : false)
  }, [dispatch, checkData])

  useEffect(() => {
    // 模版列表
    dispatch(getPrintTemplateSettingList({ current: 1, size: 500 }))
      .then(unwrapResult)
      .then((v: any) => {
        const data = v?.map((i: any) => {
          return { ...i, templateId: i?.templateId?.toString() }
        })
        setTemplateList(data?.filter((v: any) => v?.state == 1))
      })
  }, [])

  const getAllCheckData = () => {
    dispatch(getAllPersonalPreferences({ userId: id ? id : userId }))
      .then(unwrapResult)
      .then((c: any) => {
        const allPersonalPreferences = JSON.stringify(c)
        localStorage.setItem('allPersonalPreferences', allPersonalPreferences)
      })
  }

  return (
    <>
      <div className={styles.otherSettings}>
        <Form
          style={{ height: '100%' }}
          form={form}
          onFinish={(values) => {
            if (values[Checks.FPXZ]?.length > 10) {
              notification.info({
                message: '最多只能添加10个模板',
              })
              return
            }

            const pattern = /^[1-9]*$/
            const f =
              values &&
              _.chain(values)
                .pickBy((_, k) => pattern.test(k))
                .mapValues(
                  (v, k: any) =>
                  ({
                    code: k,
                    codeName:
                      // Checks.XCXQX 小程序权限
                      // Checks.TLXCFHBBHB 同类型处方合并不合并
                      // Checks.JSHZDTDYYL 结算后自动跳打印预览
                      // Checks.FPXZ 自动打印
                      k == Checks.XCXQX || k == Checks.TLXCFHBBHB || k == Checks.JSHZDTDYYL ? (v ? true : false)
                        : k == Checks.FPXZ ? (printFlag && v?.length ? v?.join(',') : '')
                          : typeof v === 'number' || typeof v === 'string' ? v?.toString()
                            : v?.toString(),
                    userId: id ? id : userId,
                  } as Settinglable)
                )
                .values()
                .value()

            const uniqueF = _.uniqBy(f, 'code')
            setSubmitLoading(true)
            dispatch(saveSetting(uniqueF))
              .then(unwrapResult)
              .then(() => {
                notification.success({
                  message: '保存成功',
                  duration: 3,
                })
                getShowData()
                getAllCheckData()
              })
              .finally(() => {
                setSubmitLoading(false)
              })
          }}
        >
          <div className={styles.formContent}>
            <Spin spinning={loading} style={{ paddingTop: '200px' }}>

              {/* 输入法设置 */}
              <Label label='输入法设置' style={{ fontSize: 17 }} noIcon={true}/>
              <Divider dashed style={{ margin: 0, marginBottom: 10 }} />
              <Row>
                <Form.Item
                  label='输入法设置'
                  name={Checks.SRFSZ}
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                  initialValue={'0'}
                >
                  <Radio.Group>
                    <Radio value='0'>拼音</Radio>
                    <Radio value='1'>
                      <div style={{ display: 'flex' }}>
                        <div>五笔</div>
                        <div style={{ marginLeft: '100px' }}>
                          （说明：作用于处方、疾病、模版搜索）
                        </div>
                      </div>
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              </Row>

              {/* 小程序设置 */}
              {id ? <>
                <Label label='小程序设置' style={{ fontSize: 17 }} noIcon={true}/>
                <Divider dashed style={{ margin: 0, marginBottom: 10 }} />
                <Row>
                  <Form.Item
                    label='小程序权限'
                    name={Checks.XCXQX}
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                    }}
                    valuePropName='checked'
                  >
                    <Checkbox />
                  </Form.Item>
                </Row>
              </> : <></>}

              { }
              <Label label='打印设置' style={{ fontSize: 17 }} noIcon={true}/>
              <Divider dashed style={{ margin: 0, marginBottom: 10 }} />
              <Row>
                <Form.Item
                  label='结算后自动跳打印预览'
                  name={Checks.JSHZDTDYYL}
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                  valuePropName='checked'
                >
                  <Checkbox><span>开启</span><span style={{ marginLeft: '8px', fontSize: '12px', color: '#999' }}>(开启后，收费结束后系统会自动弹出“选择打印模版”弹窗；如不需要则不要开启)</span></Checkbox>
                </Form.Item>
              </Row>
              <Row className={styles.noMarginBottom}>
                <Col style={{ textAlign: 'right', width: 150 }}>
                  <span>自动打印&nbsp;:&nbsp;&nbsp;</span>
                </Col>
                <Col span={16} style={{ display: 'flex' }}>
                  <Checkbox
                    checked={printFlag}
                    onChange={(v) => {
                      setPrintFlag(v?.target.checked)
                    }}
                  >
                    开启 <span style={{ marginLeft: 10 }}>结算后自动打印/开票模版选择</span>
                  </Checkbox>
                  <Form.Item
                    name={Checks.FPXZ}
                    style={{
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'row',
                    }}
                  >
                    <Select
                      style={{ width: '100%' }}
                      className={styles.addtion}
                      mode='multiple'
                      showArrow
                      showSearch={false}
                    >
                      {templateList?.map((v: any) => (
                        <Option key={v?.templateId} value={v?.templateId}>
                          {v?.templateDesc}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24} style={{ marginLeft: '144px' }}>
                  <Form.Item
                    label=''
                    name={Checks.TLXCFHBBHB}
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                    }}
                    initialValue={true}
                  >
                    <Radio.Group>
                      <Radio value={true}>同类型处方合并</Radio>
                      <Radio value={false}>
                        同类型处方不合并
                      </Radio>
                    </Radio.Group>
                  </Form.Item></Col>
              </Row>
            </Spin>
          </div>
          <Row style={{ paddingTop: '10px', justifyContent: 'center', }}>

            <Button

              onClick={() => {
                getShowData()
              }}
              style={{
                marginRight: '10px',
              }}
            >
              取消
            </Button>
            <Button
              loading={submitLoading}
              type='primary'
              onClick={() => {
                form.submit()
              }}
            >
              保存
            </Button>
          </Row>
        </Form>
      </div>
    </>
  )
}
